/**
 * Small circular saving indicator used inside Quill editor frames.
 *
 * @param {Object} props
 * @param {string} [props.label="Saving changes"] - Accessible status label.
 * @returns {JSX.Element}
 */
const SavingCircle = ({ label = "Saving changes" }) => (
  <div
    className="absolute right-2 bottom-2 z-20 flex h-6 w-6 items-center justify-center rounded-full bg-white/95 shadow-sm ring-1 ring-gray-200"
    role="status"
    aria-live="polite"
    title={label}
  >
    <span className="h-3 w-3 animate-spin rounded-full border-2 border-gray-400 border-t-transparent" />
    <span className="sr-only">{label}</span>
  </div>
);

export default SavingCircle;
